<script>
    import {onMount} from 'svelte';

    let counter = 0 // @hmr:keep

    onMount(() => {
      console.log('Mounting HmrDisplay')
      const interval = setInterval(() => {
        counter++
      }, 1000)
      return () => {
        clearInterval(interval)
      }
    })
</script>
